let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gsf2D")).then(() => parcelRequire('iFgsP'));